import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const guides = [
  {
    number: '09',
    title: 'Qué es el yoga mamá-bebé y por qué funciona',
    description: 'El contacto piel con piel libera oxitocina en ambos. El movimiento rítmico activa el sistema vestibular — el mismo que lo calmaba en el útero. No es ejercicio. Es el idioma más antiguo entre una mamá y su hijo.',
  },
  {
    number: '10',
    title: 'Secuencia de yoga 0 a 3 meses',
    description: 'El sistema nervioso del recién nacido está construyendo sus conexiones. El movimiento suave y el contacto aceleran ese proceso. 5 posturas desde el piso, sin separarse, para las primeras semanas de vida juntas.',
  },
  {
    number: '11',
    title: 'Secuencia de yoga 3 a 6 meses',
    description: 'Tu bebé empieza a descubrir sus manos, a controlar su cabeza, a buscar tu mirada. 5 posturas que incorporan su movimiento activo y convierten tu cuerpo en su parque de juegos más seguro.',
  },
  {
    number: '12',
    title: 'Secuencia de yoga 6 a 12 meses',
    description: 'El gateo activa simultáneamente ambos hemisferios cerebrales. Es el movimiento más completo del desarrollo infantil. 5 posturas que acompañan ese proceso y preparan a tu bebé para ponerse de pie.',
  },
  {
    number: '13',
    title: 'Regulación emocional profunda para mamá',
    description: 'Una secuencia de 15 minutos solo para vos. Sin bebé, sin culpa, sin apuro. Posturas de apertura de cadera, respiración 4-7-8 y meditación breve. Porque cuidarte es la inversión más grande que podés hacer por tu hijo.',
  },
  {
    number: '14',
    title: 'La práctica nocturna — el ritual de cierre del día',
    description: 'La secuencia nocturna completa de 20 minutos mamá-bebé. Postura de la luna, masaje de pies, postura de la mariposa, savasana juntos. El momento en que todo el ruido del día se apaga y solo quedan dos cuerpos respirando juntos en la oscuridad.',
  },
];

const heroImage = 'https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/3715bfe4-0970-494d-b559-2a96922570a1_compressed_ChatGPT-Image-10-ago-2026-01_32_53-a.m..webp';

export default function YogaSuenoProfundo() {
  const [hoveredGuide, setHoveredGuide] = useState<number | null>(null);
  const { t, i18n } = useTranslation();

  // Checkout de Hotmart segun el idioma de la pagina
  const checkoutUrl =
    i18n.language === 'en'
      ? 'https://pay.hotmart.com/J107839719H'
      : 'https://pay.hotmart.com/I107838862Y';

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                Programa
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                Yoga
                <br />
                <span className="font-bold">Sueño Profundo</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                Tu cuerpo ya sabe cómo calmar a tu bebé. Esta programa te enseña a escucharlo.
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-user-smile-line text-xs" />
                  Bebés 0 a 12 meses
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-file-text-line text-xs" />
                  14 guías en PDF
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-book-3-line text-xs" />
                  Incluye Fundamentos del Sueño
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  Acceso de por vida
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$67</span>
                <span className="font-sans text-sm text-[#5C4A3A]">USD — Pago único</span>
              </div>
              <a
                href={checkoutUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-terracotta text-white px-8 py-3.5 rounded-full font-sans text-sm font-semibold hover:bg-brown transition-colors duration-300 w-fit cursor-pointer"
              >
                {t('common.comprar_67usd')}
                <i className="ri-shopping-cart-line" />
              </a>
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt="Madre con bebé en yoga mamá-bebé, ambiente cálido y sereno"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-heart-line text-3xl text-cream" />
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-cream leading-tight mb-8">
            Hay algo que ningún método te va a dar
          </h2>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            Ninguna app, ningún libro, ningún experto. Es esto: la certeza de que tu cuerpo es el lugar más seguro del mundo para tu bebé.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            Que tu voz lo calma porque lo conoce desde adentro. Que tu temperatura, tu olor, tu respiración son datos que su cerebro interpreta como hogar.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed">
            Este programa existe para que lo descubras. Y para que nunca más lo olvides.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              6 Guías Nuevas en PDF
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              Lo que vas a recibir
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              Secuencias de yoga mamá-bebé diseñadas para cada etapa del desarrollo. Movimiento consciente, contacto intencional, amor en cada postura.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {guides.map((guide, index) => (
              <div
                key={guide.number}
                className="bg-white rounded-2xl p-6 md:p-8 border border-sand/40 transition-all duration-300 hover:border-terracotta/30"
                onMouseEnter={() => setHoveredGuide(index)}
                onMouseLeave={() => setHoveredGuide(null)}
              >
                <div className="flex items-start gap-4 md:gap-6">
                  <div className="flex-shrink-0">
                    <span className="font-serif text-4xl md:text-5xl font-light text-[#5C4A3A] leading-none">
                      {guide.number}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-serif text-xl md:text-2xl font-bold text-[#8B6F5C] mb-3 leading-tight">
                      {guide.title}
                    </h3>
                    <p className="font-sans text-sm text-[#3D2B1F] leading-relaxed">
                      {guide.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
            <div className="w-full md:w-1/2">
              <div className="w-14 h-14 rounded-2xl bg-[#AAB7A3]/20 flex items-center justify-center mb-6">
                <i className="ri-stack-line text-2xl text-[#AAB7A3]" />
              </div>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-6">
                Este programa incluye
                <br />
                <span className="font-bold">todo lo de Fundamentos del Sueño</span>
                <br />
                <span className="text-[#C58D72]">más:</span>
              </h2>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                Las 8 guías de Fundamentos del Sueño (valoradas en $27) ya están adentro. Y además, recibís 6 guías nuevas exclusivas de yoga mamá-bebé.
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed">
                Es como tener dos programas en uno. El conocimiento científico + la práctica corporal. El entender + el sentir. El pensar + el hacer.
              </p>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sand/30">
                <h3 className="font-serif text-2xl font-bold text-[#8B6F5C] mb-6">
                  ¿Qué incluye?
                </h3>
                <ul className="flex flex-col gap-4">
                  {[
                    '14 guías en PDF descargables',
                    'Incluye Fundamentos del Sueño completo',
                    '6 guías nuevas con secuencias de yoga mamá-bebé',
                    'Secuencias para cada etapa: 0-3, 3-6 y 6-12 meses',
                    'Guía de regulación emocional profunda para mamá',
                    'Ritual nocturno completo paso a paso',
                    'Acceso de por vida sin suscripción',
                    'Sin métodos de dejar llorar',
                    'Para bebés de 0 a 12 meses',
                  ].map((item) => (
                    <li key={item} className="flex items-center gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#AAB7A3]/20 flex-shrink-0">
                        <i className="ri-check-line text-[#AAB7A3] text-sm" />
                      </div>
                      <span className="font-sans text-sm text-[#3D2B1F]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-eye-off-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            &ldquo;Lo esencial es invisible a los ojos. El amor con el que tu madre te tuvo no estaba en ningún lugar de su cuerpo. No se puede tocar, no se puede ver. Pero por ese amor invisible, vos naciste. Y ese mismo amor invisible es el que vos sentís ahora, cada vez que tu bebé se calma en tus brazos. Eso no se aprende. Eso se es. Y este programa te ayuda a confiar en lo que ya sos.&rdquo;
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            — El Principito, y también nosotros
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            Empezá hoy
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            14 guías. Un cuerpo que sabe. Un bebé que siente.
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$67</span>
            <span className="font-sans text-base text-[#5C4A3A]">USD</span>
          </div>
          <a
            href={checkoutUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-terracotta text-white px-10 py-4 rounded-full font-sans text-base font-semibold hover:bg-brown transition-colors duration-300 mb-4 cursor-pointer"
          >
            {t('common.comprar_67usd')}
            <i className="ri-shopping-cart-line" />
          </a>
          <p className="font-sans text-sm text-[#5C4A3A]">
            Acceso inmediato a las 14 guías en PDF. Incluye Fundamentos del Sueño. Acceso de por vida.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}